(function () {
  var staleMarkers = [
    'Joy Chocolate styling for Sendwill/EcomSend popup surfaces',
    '--joy-popup-image',
    'Ya-Hala-Gift-Box-Studio-Shot-_2.jpg'
  ];

  function isStaleEcomsendCss(cssText) {
    return staleMarkers.some(function (marker) {
      return cssText.indexOf(marker) !== -1;
    });
  }

  function clearStaleEcomsendCss() {
    var styleElement = document.getElementById('ecomsend-custom-style');

    if (!styleElement) {
      return;
    }

    var cssText = styleElement.textContent || '';

    if (!isStaleEcomsendCss(cssText)) {
      return;
    }

    styleElement.textContent = '';
    styleElement.setAttribute('data-joy-stale-css-cleared', 'true');
  }

  clearStaleEcomsendCss();
  document.addEventListener('DOMContentLoaded', clearStaleEcomsendCss);
  window.addEventListener('load', clearStaleEcomsendCss);

  var observer = new MutationObserver(clearStaleEcomsendCss);
  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
